<template>
  <div class="special_radio">
    <div class="title_h1">日程回答</div>
    <vab-collapse-info :disabled="!isSave">
      <template slot="title">
        {{ getFieldValue('demandBaseIdModel.title', info) }}［{{
          getFieldValue('acceptOrderNo', info)
        }}］
      </template>
      <template v-if="showDownLoad" slot="upload">
        <div
          class="flex_center_align"
          :class="{ disabled_file_name: !isSave }"
          @click="downLoadDateFile"
        >
          <span class="file_name">見積情報ダウンロード</span>
          <svg-icon
            icon-class="download_2_line"
            class="upload_svg arrow"
          ></svg-icon>
        </div>
      </template>
      <template slot="link">発注変更</template>
      <template slot="row">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">建物</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            {{ getFieldValue('buildingCdModel.blgsnmkj', info) }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">商品</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{ getFieldValue('demandBaseIdModel.itemCdModel.itmnm', info) }}
          </vab-col>
          <vab-col :span="4" class="title_box">商品明細</vab-col>
          <vab-col :span="8" class="word_box center_box">
            <div
              v-for="(item, index) in mitmdtlpModelList"
              :key="index"
              class="flex_space width_100"
            >
              <div>
                {{ getFieldValue('itmdtlnm', item) }}
              </div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">依頼件名</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            {{ getFieldValue('requestIdModel.constructionName', info) }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">案件分類</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue('demandBaseIdModel.businessForm', info),
                $divisions.consignmentWorkClassEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">依頼区分</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue('requestIdModel.requestClass', info),
                $divisions.requestClassEnum
              )
            }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">進行部門</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getFieldValue(
                'demandBaseIdModel.progressDepCdModel.orgkjrn',
                info
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">進行担当者</vab-col>
          <vab-col :span="8" class="word_box center_box">
            <div
              v-for="(item, index) in getFieldValue(
                'demandBaseIdModel.demandChargePersonModelList',
                info
              )"
              :key="index"
            >
              {{ getFieldValue('empnmkj', item.chargePersonCdModel) }}
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">日程調整状況</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                info.adjScheduleStatus,
                $divisions.adjScheduleStatusEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">日程回答期限</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{ getFieldValue('requestIdModel.scheduleLimitDate', info) }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">書類提出期限</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{ getFieldValue('requestIdModel.docLimitDate', info) }}
          </vab-col>
          <template
            v-if="
              isEqualCodeEnum(
                getFieldValue('requestIdModel.requestClass', info),
                $divisions.requestClassEnum.enum_1
              )
            "
          >
            <vab-col :span="4" class="title_box">事前調査要否</vab-col>
            <vab-col :span="8" class="word_box flex_center_align">
              {{
                getEnumText(
                  getFieldValue('requestIdModel.investigationFlg', info),
                  $divisions.investigationFlgEnum
                )
              }}
            </vab-col>
          </template>
          <template v-else>
            <vab-col :span="4" class="title_box">土日休工要否</vab-col>
            <vab-col :span="8" class="word_box flex_center_align">
              {{
                getEnumText(
                  getFieldValue('requestIdModel.weekdayClosedFlg', info),
                  $divisions.necessaryFlagEnum
                )
              }}
            </vab-col>
          </template>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">工事内容</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            {{ getFieldValue('requestIdModel.constructionDetail', info) }}
          </vab-col>
        </vab-row>
      </template>
    </vab-collapse-info>
    <div class="info_main new_workInfo">
      <div
        class="head_box flex_start flex_center_align"
        style="padding-top: 12px"
      >
        <svg-icon icon-class="edit_2_line"></svg-icon>
        <span class="hd_title">日程調整</span>
      </div>
      <div class="h_date flex_center_align">
        <svg-icon icon-class="tryangle_down" class="h_svg"></svg-icon>
        <span class="h_title h_img_none">候補日程を登録してください</span>
      </div>
      <vab-form ref="form" :model="form" :rules="rules">
        <div class="sure_box top_info mtn">
          <vab-row
            v-if="
              checkEnumFlag(getFieldValue('requestIdModel.requestClass', info))
            "
            class="row_box"
          >
            <vab-col :span="4" class="title_box">対応判断</vab-col>
            <vab-col :span="20" class="word_box flex_center_align pdtb8">
              <vab-radio-group
                ref="dealingFlgRef"
                label=""
                label-width="0"
                prop="dealingFlg"
                filter="dealingFlg"
                :disabled="dealingDisable"
                @change="disableWattingList"
              ></vab-radio-group>
            </vab-col>
          </vab-row>
          <vab-row
            v-if="
              isEqualCodeEnum(
                getFieldValue('requestIdModel.requestClass', info),
                $divisions.requestClassEnum.enum_2
              ) &&
              isEqualCodeEnum(
                getFieldValue('demandType', info),
                $divisions.demandTypeEnum.enum_2
              )
            "
            class="row_box"
          >
            <vab-col :span="4" class="title_box">報告書提出予定月</vab-col>
            <vab-col :span="20" class="word_box flex_center_align pdtb8">
              <div class="tz_right w140">
                <vab-date-picker
                  type="month"
                  :label-show="false"
                  value-format="yyyy/MM/01"
                  format="yyyy/MM"
                  prop="reportSubmitYearMonth"
                  :disabled="dealingDisable"
                />
              </div>
            </vab-col>
          </vab-row>
          <div v-if="form.scheduleAdjDetailModelList.length > 0">
            <template v-for="(row, index) in form.scheduleAdjDetailModelList">
              <vab-row v-if="row.show" :key="index" class="row_box">
                <vab-col :span="4" class="title_box">
                  <div class="flex_colum">
                    <div>{{ getSecTitile(row, index + 1) }}</div>
                    <div
                      class="clear_btn"
                      :class="
                        dealingDisable || dealingFlgData ? 'disabledBtn ' : ''
                      "
                      @click="clear(index)"
                    >
                      クリア
                    </div>
                  </div>
                </vab-col>
                <vab-col :span="20" class="word_box nopadding">
                  <vab-row class="flex_center_align pdtb8">
                    <div class="line_boder margin_8"></div>
                    <vab-col class="flex_center_align picker_label">
                      <span class="tz_title">日程</span>
                    </vab-col>
                    <vab-col class="date_picker width_auto">
                      <div class="flex_start tz_right flex_center_align">
                        <vab-date-picker
                          type="date"
                          :label-show="false"
                          value-format="yyyy/MM/dd"
                          format="yyyy/MM/dd"
                          :validate="vaildateTimeStart(row, index)"
                          :prop="`scheduleAdjDetailModelList.${index}.startDateTime`"
                          :end-date-prop="`scheduleAdjDetailModelList.${index}.endDateTime`"
                          :disabled="row.timeDisabled"
                          :clearable="false"
                          @change="
                            (value) =>
                              changeWattingDate(
                                row,
                                index,
                                value,
                                'startDateTime'
                              )
                          "
                        />
                        <div class="line">～</div>
                        <vab-date-picker
                          type="date"
                          :label-show="false"
                          value-format="yyyy/MM/dd"
                          format="yyyy/MM/dd"
                          :validate="vaildateTimeEnd(row, index)"
                          :prop="`scheduleAdjDetailModelList.${index}.endDateTime`"
                          :start-date-prop="`scheduleAdjDetailModelList.${index}.startDateTime`"
                          :disabled="row.timeDisabled"
                          :clearable="false"
                          @change="
                            (value) =>
                              changeWattingDate(
                                row,
                                index,
                                value,
                                'endDateTime'
                              )
                          "
                        />
                      </div>
                    </vab-col>
                  </vab-row>
                  <vab-row class="margin_8">
                    <vab-col class="flex_center_align picker_label">
                      <span class="tz_title">時間</span>
                    </vab-col>
                    <vab-col class="time_picker">
                      <div class="flex_start flex_center_align">
                        <vab-time-picker
                          :prop="`scheduleAdjDetailModelList.${index}.startTime`"
                          format="HH:mm"
                          value-format="HH:mm"
                          :value-format-sss="true"
                          :disabled="row.disabled"
                          :end-date-prop="`scheduleAdjDetailModelList.${index}.endTime`"
                          @change="(value) => changeWattingTime(row)"
                        ></vab-time-picker>
                        <div class="line">～</div>
                        <vab-time-picker
                          :prop="`scheduleAdjDetailModelList.${index}.endTime`"
                          format="HH:mm"
                          value-format="HH:mm"
                          :value-format-sss="true"
                          :disabled="row.disabled"
                          :start-date-prop="`scheduleAdjDetailModelList.${index}.startTime`"
                          @change="(value) => changeWattingTime(row)"
                        ></vab-time-picker>
                        <div class="end_box">
                          <vab-checkbox
                            :ref="'dayFlagRef' + index"
                            label="終日"
                            :prop="`scheduleAdjDetailModelList.${index}.dayFlag`"
                            :code-enum="$divisions.validFlgEnum"
                            :disabled="row.checkDisabled"
                            :class="
                              row.checkDisabled ? 'checkbox_disabled' : ''
                            "
                            @change="(value) => changeDayFlag(value, row)"
                          ></vab-checkbox>
                        </div>
                      </div>
                    </vab-col>
                  </vab-row>
                </vab-col>
              </vab-row>
            </template>
          </div>
          <vab-collapse
            :title="'カレンダーを閉じる'"
            :dot="true"
            class="message_collapse"
          >
            <div class="los_box">
              <vab-calendar ref="calendar"></vab-calendar>
            </div>
          </vab-collapse>
          <div class="file_box norborder m7">
            <vab-row
              v-if="
                isEqualCodeEnum(
                  info.demandType,
                  $divisions.demandTypeEnum.enum_3
                ) && fileList.length > 0
              "
              class="row_box"
            >
              <vab-col :span="4" class="title_box">
                <div class="flex_colum">
                  <div class="gyzl">共有資料</div>
                </div>
              </vab-col>
              <vab-col
                :span="20"
                class="common_data_file word_box border_left_none"
              >
                <div v-if="fileList.length > 0" class="common_data_file_box">
                  <div class="inner_box common_data_file_box">
                    <div class="word_col_upload_filebox">
                      <div
                        v-for="(item, f) in fileList"
                        :key="f"
                        class="file_inner_item flex_start pl0"
                        :class="{ disabled_file_name: disabledFileName(item) }"
                      >
                        <div class="arrow_box">
                          <svg-icon icon-class="tryangle_right" class="arrow" />
                        </div>
                        <div class="file_name_out_box">
                          <div class="flex_colum file_name_box">
                            <span class="file_name" @click="downLoadFile(item)">
                              {{ item.fileName }}
                            </span>
                            <div class="file_time">
                              アップロード日時：{{ item.createDate }}
                              {{ formatTimeMsel(item.createTime) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <vab-row class="bj20" style="margin-top: 20px">
                  <vab-col :span="1" class="pt10">備考</vab-col>
                  <vab-col :span="23" class="nopadding2">
                    <vab-textarea
                      type="textarea"
                      prop="toPartnerFilesRemarks"
                      rows="5"
                      maxlength="1170"
                      :disabled="true"
                    ></vab-textarea>
                  </vab-col>
                </vab-row>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">協力会社コメント</vab-col>
              <vab-col :span="20" class="word_box nopadding2 pdtb8">
                <vab-textarea
                  type="textarea"
                  prop="submitRemarks"
                  rows="5"
                  maxlength="1170"
                ></vab-textarea>
              </vab-col>
            </vab-row>
          </div>
          <vab-message
            :title="'コメント履歴を閉じる'"
            :msg-type="$divisions.adjSourceClassEnum.enum_1.value"
            :msg-id="$route.query.requestDetailId"
            class="change_box nomargin detail_nopadding"
          ></vab-message>
        </div>
      </vab-form>
      <div class="flex_end mg12">
        <vab-button :btn-list="btnList"></vab-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    scheduleAdjustmentInfo,
    submitSchedule,
    candidateDate,
    calendar,
    reqDocMany,
    downloadCommonData,
    estimateCooperateInfo,
    estimateBriefBaseInfo,
  } from '@/api/scheduleAdjustment'
  import mixinPage from '@/utils/mixinPage'
  import mixinSchedule from '@/utils/mixinSchedule'
  import mixOperationType from '@/utils/mixOperationType'
  export default {
    name: 'PWS02G02',
    mixins: [mixinPage, mixinSchedule, mixOperationType],
    provide() {
      return {
        formData: () => this.form,
        pageInfo: () => this.info,
        setTimeList: this.setTimeList,
        vmData: this,
      }
    },
    data() {
      return {
        info: {},
        form: {
          scheduleAdjDetailModelList: [],
          scheduleAdjId: null,
        },
        rules: {},
        tzList: [],
        fileList: [],
        dealingDisable: false,
        needToConfirm: false,
        btnList: [
          {
            name: '回答',
            icon: 'answer',
            msg: this.$t(`validateMessage.${this.$messageCode.I00000415.name}`),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000440.name}`
            ),
            type: 'button',
            hidden: false,
            click: (row) => {
              this.submitForm(row)
            },
          },
        ],
        isSave: true,
      }
    },
    computed: {
      enAdjScheduleStatus4() {
        return this.isEqualCodeEnum(
          this.getFieldValue('adjScheduleStatus', this.info),
          this.$divisions.adjScheduleStatusEnum.enum_4
        )
      },
    },
    mounted() {
      this.initData()
    },
    methods: {
      async initData() {
        // 依頼詳細ｉｄ
        try {
          this.$baseColorfullLoading()
          let requestDetailId = this.$route.query?.requestDetailId
          if (requestDetailId) {
            await this.getScheduleAdjRequestInfo(requestDetailId)
          }
        } finally {
          this.$baseColorfullLoading().close()
        }
      },
      addList() {
        let data = {
          startDateTime: null,
          endDateTime: null,
          startTime: null,
          endTime: null,
          dayFlag: 0,
          disabled: true,
          checkDisabled: true,
          timeDisabled: false,
          operationType: null,
          show: true,
        }
        this.form.scheduleAdjDetailModelList.push(data)
      },
      async submitDataFormCheck(row) {
        let submitData = {
          scheduleAdjId: this.getFieldValue(
            'scheduleAdjustmentModelList[0].scheduleAdjId',
            this.info
          ),
          requestDetailId: this.$route.query?.requestDetailId,
          worksUnavailableDayOutModelList: this.$refs.calendar.noDayList,
          needToConfirm: this.needToConfirm,
        }
        let info = JSON.parse(JSON.stringify(this.info))
        submitData.requestDetailIdModel = {
          ...info,
          reportSubmitYearMonth: this.form.reportSubmitYearMonth,
          dealingFlg: this.form.dealingFlg,
        }
        submitData.submitRemarks = this.form.submitRemarks
        submitData.scheduleAdjDetailModelList =
          this.getScheduleAdjDetailModelList(
            this.form.scheduleAdjDetailModelList
          )
        submitData.worksUnavailableDayOutModelList =
          this.$refs.calendar.noDayList
        try {
          this.$baseColorfullLoading()
          const res = await submitSchedule(submitData)
          if (!res) {
            this.msgSuccess(row.word)
            this.$closePage(this.$route.path)
            this.$routerPushAndReload({
              path: '/pws/PWS02G01',
              refresh: 'PWS02G01',
            })
          }
        } finally {
          this.$baseColorfullLoading().close()
        }
      },
      async submitForm(row) {
        if (this.form.scheduleAdjDetailModelList.length > 0) {
          if (
            !this.form.scheduleAdjDetailModelList.some(
              (item) => item.startDateTime && item.endDateTime
            ) &&
            this.checkEnumFlag(this.form.dealingFlg)
          ) {
            this.msgError(
              this.format(
                this.$t(`validateMessage.${this.$messageCode.E00000041.name}`),
                '候補日程'
              )
            )
            return
          }
        }
        this.$refs['form'].validate((valid, obj) => {
          if (valid) {
            this.submitDataFormCheck(row)
          } else {
            var a = []
            for (let key in obj) {
              a.push(obj[key][0].message)
            }
            this.$message({
              message: a[0],
              type: 'error',
            })
            return false
          }
        })
      },
      // 詳細はこちら
      async getScheduleAdjRequestInfo(requestDetailId) {
        const loadingInstance = this.$baseColorfullLoading()
        try {
          const res = await scheduleAdjustmentInfo(requestDetailId)
          this.info = res
          // 協力会社へ共有資料（見積条件書） 見積協力依頼.見積協力送信日 ＝ 削除期限日 書類ファイルを削除
          if (res?.requestIdModel?.estimateCooperateId && !this.isSc3) {
            const { estimateCooperateSendDate } = await estimateCooperateInfo(
              res?.requestIdModel?.estimateCooperateId
            )
            this.isSave = this.disabledFileNameByDate(estimateCooperateSendDate)
          } else if (res?.demandBaseId && this.isSc3) {
            // 協力会社へ共有資料（診断概要書） 見積概要書.変更日 ＝ 削除期限日 書類ファイルを削除
            const { changeDate } = await estimateBriefBaseInfo(
              res?.demandBaseId
            )
            this.isSave = this.disabledFileNameByDate(changeDate)
          }
          this.form.reportSubmitYearMonth = res?.reportSubmitYearMonth
          // ボタンの設定
          this.setBtnList()
          // 希望開始日・終了日
          this.hopeList = this.changeHopeDateList(
            this.getFieldValue('requestIdModel.expectStartDate', res),
            this.getFieldValue('requestIdModel.expectEndDate', res)
          )
          this.setGoodsInfoList(this.info)
          await this.getDateList(requestDetailId)
          // 日程調整依頼詳細の依頼対応区分は、デフォルト値が「"1":日程調整要」
          // 日程調整依頼の調査要否「"1":要」の場合、日程調整依頼詳細の依頼対応区分には、「"0":日程調整不要」選択できません
          // 日程調整依頼の調査要否「"0":不要」の場合、日程調整依頼詳細の依頼対応区分には、「"1":日程調整要」選択できません、デフォルト値が「"0":日程調整不要」
          this.checkInfoDealingFlg()
          // 日付入力を無効にする
          if (
            this.checkEnumFlag(
              this.getFieldValue('requestIdModel.requestClass', this.info)
            )
          ) {
            this.disableWattingList(res.dealingFlg)
          }
          // 共有資料
          this.getCommonFileList()
          // 日程回答-カレンダー
          this.getCalendarList({
            requestYearMonth: this.getRequestYearMonth(
              this.form.scheduleAdjDetailModelList
            ),
          })
          // 調整済み 無効化
          if (
            this.isEqualCodeEnum(
              this.info.adjScheduleStatus,
              this.$divisions.adjScheduleStatusEnum.enum_4
            )
          ) {
            this.form.scheduleAdjDetailModelList.filter((item) => {
              item.disabled = true
              item.checkDisabled = true
              item.timeDisabled = true
              this.$set(item, 'timeDisabled', true)
            })
            this.dealingDisable = true
          }
          this.form.toPartnerFilesRemarks = this.info.toPartnerFilesRemarks
        } finally {
          loadingInstance.close()
        }
      },
      checkInfoDealingFlg() {
        // 依頼区分	1
        if (
          this.checkEnumFlag(
            this.getFieldValue('requestIdModel.requestClass', this.info)
          ) &&
          this.$baseLodash.isEmpty(this.info.dealingFlg)
        ) {
          this.dealingFlgCheck(this.info, this.form, 'add')
        } else {
          let value = this.$divisions.dealingFlgEnum.enum_1.value
          if (!this.$baseLodash.isEmpty(this.info.dealingFlg)) {
            value = this.info.dealingFlg
          }
          this.dealingFlgCheck(this.info, this.form)
          if (this.$refs.dealingFlgRef) {
            this.$refs.dealingFlgRef.setValue(value)
          }
          this.form.dealingFlg = value
        }
      },
      async getDateList(requestDetailId) {
        // 	③上記②で取得した日程調整状況は「"2":提出済、"4":調整済、"5":差戻、"6":再調整、"7":着工広報対応中、"8":着工広報対応済」の場合、候補日リスト情報を取得する。
        if (
          !this.isEqualCodeEnum(
            this.info.adjScheduleStatus,
            this.$divisions.adjScheduleStatusEnum.enum_1
          )
        ) {
          //取得する候補日リスト
          let res = await candidateDate(requestDetailId)
          if (res?.length && res.length > 0) {
            this.setInfoDateList(res)
            this.setWattingList(res)
            this.initTableList = this.$baseLodash.cloneDeep(res)
          } else {
            // 案件タイプ							依頼区分									候補日程の入力件数
            this.setScheduleAdjDetailList(
              this.info.demandType,
              this.getFieldValue('requestIdModel.requestClass', this.info)
            )
            this.hopeDateListFill(
              this.getFieldValue('requestIdModel.expectStartDate', this.info),
              this.getFieldValue('requestIdModel.expectEndDate', this.info)
            )
            this.setCalendarDayList()
          }
        } else {
          // 案件タイプ							依頼区分									候補日程の入力件数
          this.setScheduleAdjDetailList(
            this.info.demandType,
            this.getFieldValue('requestIdModel.requestClass', this.info)
          )
          this.hopeDateListFill(
            this.getFieldValue('requestIdModel.expectStartDate', this.info),
            this.getFieldValue('requestIdModel.expectEndDate', this.info)
          )
          this.setCalendarDayList()
        }
      },
      // 初期化カレンダーの候補日程
      setCalendarDayList() {
        const cloneList = this.$baseLodash.cloneDeep(
          this.form.scheduleAdjDetailModelList
        )
        this.$refs.calendar.list = cloneList.map((row, index) => {
          return {
            ...row,
            title: '候補日程' + (index + 1),
          }
        })
      },
      // ボタンのテキストを動的に表示
      setBtnList() {
        this.btnList = [
          {
            name: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('adjScheduleStatus', this.info),
                  this.$divisions.adjScheduleStatusEnum.enum_2
                )
              ) {
                return '再回答'
              } else {
                return '回答'
              }
            })(),
            icon: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('adjScheduleStatus', this.info),
                  this.$divisions.adjScheduleStatusEnum.enum_2
                )
              ) {
                return 'answer2'
              } else {
                return 'answer'
              }
            })(),
            msg: this.$t(`validateMessage.${this.$messageCode.I00000415.name}`),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000440.name}`
            ),
            type: 'button',
            hidden: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('adjScheduleStatus', this.info),
                  this.$divisions.adjScheduleStatusEnum.enum_4
                )
              ) {
                return true
              } else {
                return false
              }
            })(),
            click: (row) => {
              this.submitForm(row)
            },
          },
          {
            name: '再提出依頼',
            icon: 'answer2',
            msg: this.format(
              this.$t(`validateMessage.${this.$messageCode.I00000191.name}`),
              '再提出依頼'
            ),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000444.name}`
            ),
            type: 'button',
            bg: '#C90022',
            hover: '#E12432',
            hidden: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('adjScheduleStatus', this.info),
                  this.$divisions.adjScheduleStatusEnum.enum_4
                )
              ) {
                return false
              } else {
                return true
              }
            })(),
            click: (row) => {
              this.submitForm(row)
            },
          },
        ]
      },
      // した案件タイプと依頼区分によって、候補日程を制御する。
      setScheduleAdjDetailList(demandType, requestClass) {
        if (
          this.isEqualCodeEnum(
            demandType,
            this.$divisions.demandTypeEnum.enum_2
          )
        ) {
          for (let index = 0; index < 3; index++) {
            this.addList()
          }
        }
        let demandTypeList = [
          this.$divisions.demandTypeEnum.enum_6.value,
          this.$divisions.demandTypeEnum.enum_1.value,
        ]
        if (
          this.isEqualCodeEnum(
            demandType,
            this.$divisions.demandTypeEnum.enum_3
          ) ||
          (demandTypeList.includes(demandType) &&
            this.isEqualCodeEnum(
              requestClass,
              this.$divisions.requestClassEnum.enum_1
            ))
        ) {
          this.addList()
        }
      },
      // 共有資料ダウンロード
      async downLoadFile(file) {
        let data = {
          reqDocId: file?.reqDocId,
          docId: file.docId,
          // 建物CD
          buildingCd: this.getFieldValue(
            'demandBaseIdModel.buildingCd',
            this.info
          ),
          // 受注キー
          acceptOrderKey: this.getFieldValue('acceptOrderNo', this.info),
          fileName: file.fileName,
        }
        await downloadCommonData(data)
      },
      // 共有資料
      async getCommonFileList() {
        if (
          !this.isEqualCodeEnum(
            this.info.demandType,
            this.$divisions.demandTypeEnum.enum_3
          )
        )
          return
        const res = await reqDocMany({
          requestDetailId: this.info.requestDetailId,
        })
        this.fileList = res
      },
      // 日程回答-カレンダー
      async getCalendarList(info) {
        let data = {
          buildingCd: this.getFieldValue(
            'demandBaseIdModel.buildingCd',
            this.info
          ),
          sectionCd: this.getFieldValue(
            'demandBaseIdModel.sectionCd',
            this.info
          ),
          excludeRequestDetailId: this.info.requestDetailId,
          requestYearMonth: info.requestYearMonth,
        }
        const loadingInstance = this.$baseColorfullLoading()
        try {
          const res = await calendar(data)
          if (res?.length && res.length > 0) {
            this.$refs.calendar.getTimes(info.requestYearMonth).then(() => {
              this.$refs.calendar.setPageData(data)
              this.$refs.calendar.setCalenderTime(res, this)
            })
          }
        } finally {
          loadingInstance.close()
        }
      },
      setInfoDateList(list, format = false) {
        if (list && list.length == 0) return
        list.filter((row, index) => {
          row.id = index + 1
          if (
            !this.$baseLodash.isEmpty(row.startDateTime) &&
            !this.$baseLodash.isEmpty(row.endDateTime)
          ) {
            let isSame = this.$dayjs(row.startDateTime).isSame(
              row.endDateTime,
              'day'
            )
            if (!isSame) {
              row.disabled = true
              row.checkDisabled = true
            } else {
              row.disabled = false
              row.checkDisabled = false
            }
          }
          row.timeDisabled = false
          row.operationType = null
          row.show = true
          // #5261
          if (
            this.isEqualCodeEnum(
              this.info.adjScheduleStatus,
              this.$divisions.adjScheduleStatusEnum.enum_4
            ) &&
            !this.checkEnumFlag(row.selectFlg)
          ) {
            row.show = false
          }
          // if (
          //   !this.$baseLodash.isEmpty(row.startDateTime) &&
          //   !this.$baseLodash.isEmpty(row.endDateTime)
          // ) {
          //   let isSame = this.$dayjs(row.startDateTime).isSame(
          //     row.endDateTime,
          //     'day'
          //   )
          //   if (!isSame) {
          //     row.disabled = true
          //     row.startTime = null
          //     row.endTime = null
          //     row.checkDisabled = true
          //   } else {
          //     row.disabled = false
          //     row.checkDisabled = false
          //     row.dayFlag = 0
          //   }
          // }
          if (!format) {
            if (this.$dayjs(row.startDateTime).isValid()) {
              row.startTime = this.$dayjs(row.startDateTime).format('HH:mm')
            }
            if (this.$dayjs(row.endDateTime).isValid()) {
              row.endTime = this.$dayjs(row.endDateTime).format('HH:mm')
            }
          } else {
            if (this.checkEnumFlag(row.dayFlag)) {
              row.disabled = true
            }
          }
        })
        this.form.scheduleAdjDetailModelList = list
        if (
          list.length < 3 &&
          this.isEqualCodeEnum(
            this.info.demandType,
            this.$divisions.demandTypeEnum.enum_2
          ) &&
          !this.isEqualCodeEnum(
            this.info.adjScheduleStatus,
            this.$divisions.adjScheduleStatusEnum.enum_4
          )
        ) {
          for (let index = 0; index <= 3 - list.length; index++) {
            this.addList()
          }
        }
      },
      setTimeList(row, index) {
        this.form.scheduleAdjDetailModelList[index] = row
        if (this.$refs['dayFlag' + index]) {
          this.$refs['dayFlag' + index][0].setValue(row.dayFlag)
        }
        this.$set(this.form.scheduleAdjDetailModelList, index, row)
      },
      // 候補スケジュールカレンダーを設定します
      setWattingList(list) {
        if (list.length > 0) {
          let hbList = []
          let colorList = ['#FA7830', '#42B86A', '#B077EA']
          let bgColor = [
            'rgba(250, 120, 48, 0.06)',
            'rgba(66, 184, 106, 0.06)',
            'rgba(176, 119, 234, 0.06)',
          ]
          list.filter((row, index) => {
            row.id = index + 1
            let data = {
              id: row.id,
              title: '候補日程' + (index + 1),
              icon: this.enAdjScheduleStatus4
                ? 'check_circle_fill'
                : 'check_circle_line',
              time: `${row.startDateTime}〜${row.endDateTime}`,
              color: this.enAdjScheduleStatus4 ? '#fff' : colorList[index % 3],
              bg: this.enAdjScheduleStatus4
                ? 'rgba(250, 120, 48, 0.9)'
                : bgColor[index % 3],
              hbbg: bgColor[index % 3],
              type: this.enAdjScheduleStatus4 ? 'dyhope' : 'watting',
              start: null,
              end: null,
              selectFlg: row.selectFlg,
            }
            if (this.$dayjs(row.startDateTime).isValid()) {
              data.start = this.$dayjs(row.startDateTime).format(
                this.$const.dateFormatYYYYMMDD
              )
            }
            if (this.$dayjs(row.endDateTime).isValid()) {
              data.end = this.$dayjs(row.endDateTime).format(
                this.$const.dateFormatYYYYMMDD
              )
            }
            // #5261
            if (
              this.isEqualCodeEnum(
                this.info.adjScheduleStatus,
                this.$divisions.adjScheduleStatusEnum.enum_4
              ) &&
              this.checkEnumFlag(row.selectFlg)
            ) {
              data.title = '確定日程'
            }
            hbList.push(data)
          })
          if (
            this.isEqualCodeEnum(
              this.info.adjScheduleStatus,
              this.$divisions.adjScheduleStatusEnum.enum_4
            )
          ) {
            this.hbList = hbList.filter((item) => item.selectFlg == '1')
          } else {
            this.hbList = hbList
          }
          this.$nextTick(() => {
            this.$refs.calendar.clearFillForm([
              ...this.hbList,
              ...this.hopeList,
            ])
          })
        }
      },
      // 候補時間を選択する
      async changeWattingDate(row, index, value, key) {
        // 2 重複する（事前調査と工事日程） #3175
        //  「SC1」の場合、デフォルト "4":調整済
        // でも、不可日または他の日程と重なるの時、"2":提出済（確認必要）
        // 以外の場合、"2":提出済
        // 「SC3」事前調査の場合、不可日を選択不可
        if (this.$baseLodash.isEmpty(value)) {
          row.disabled = true
          row.checkDisabled = true
          row.dayFlag = null
          this.form.scheduleAdjDetailModelList[index].startTime = null
          this.form.scheduleAdjDetailModelList[index].endTime = null
          this.setWattingList(this.form.scheduleAdjDetailModelList)
          return
        }
        // if (
        //   [
        //     this.$divisions.demandTypeEnum.enum_1.value,
        //     this.$divisions.demandTypeEnum.enum_6.value,
        //   ].includes(this.getFieldValue('demandType', this.info))
        // ) {
        //   let isSame = false
        //   let noDayList = this.$refs.calendar.noDayList
        //   noDayList.filter((item) => {
        //     if (!isSame) {
        //       if (this.$dayjs(item.date).isSame(value, 'day')) {
        //         isSame = true
        //       }
        //     }
        //   })
        //   if (isSame && !this.needToConfirm) {
        //     this.needToConfirm = true
        //   }
        // } else {
        //   this.needToConfirm = false
        // }
        // 「SC1」事前調査の場合、不可日を選択提醒
        if (
          (this.isEqualCodeEnum(
            this.getFieldValue('demandType', this.info),
            this.$divisions.demandTypeEnum.enum_1
          ) ||
            this.isEqualCodeEnum(
              this.getFieldValue('demandType', this.info),
              this.$divisions.demandTypeEnum.enum_6
            )) &&
          this.isEqualCodeEnum(
            this.getFieldValue('requestIdModel.requestClass', this.info),
            this.$divisions.requestClassEnum.enum_1
          )
        ) {
          // let noDayList = this.$refs.calendar.noDayList
          // if (
          //   noDayList.some((time) =>
          //     this.$dayjs(time.date).isSame(value, 'day')
          //   )
          // ) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000286.name}`)
          //   )
          // }
          // if (this.checkCalendar(value, this.$refs.calendar.calendarList)) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000217.name}`)
          //   )
          // }
          this.checkDayReportRequest(row)
        }

        // 「SC3」事前調査の場合、不可日を選択不可
        if (
          this.isEqualCodeEnum(
            this.getFieldValue('demandType', this.info),
            this.$divisions.demandTypeEnum.enum_3
          ) &&
          this.isEqualCodeEnum(
            this.getFieldValue('requestIdModel.requestClass', this.info),
            this.$divisions.requestClassEnum.enum_1
          )
        ) {
          // let noDayList = this.$refs.calendar.noDayList
          // let check = this.checkNoDay(row, value, key, noDayList)
          // if (check) {
          //   this.setWattingList(this.form.scheduleAdjDetailModelList)

          //   this.msgError(
          //     this.$t(`validateMessage.${this.$messageCode.W00000428.name}`)
          //   )
          //   return
          // }
          let error = await this.checkDayReportError(row, key, 'error')
          if (error) {
            this.setWattingList(this.form.scheduleAdjDetailModelList)
            return
          }
        }
        // 「SC3」工事・作業、不可日を選択提醒
        if (
          this.isEqualCodeEnum(
            this.getFieldValue('demandType', this.info),
            this.$divisions.demandTypeEnum.enum_3
          ) &&
          this.isEqualCodeEnum(
            this.getFieldValue('requestIdModel.requestClass', this.info),
            this.$divisions.requestClassEnum.enum_2
          )
        ) {
          // let noDayList = this.$refs.calendar.noDayList
          // let check = noDayList.some((time) =>
          //   this.$dayjs(time.date).isSame(value, 'day')
          // )
          // if (check) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000213.name}`)
          //   )
          // }
          this.checkDayReportError(row)
        }
        if (this.$baseLodash.isEmpty(row.startDateTime)) {
          row.startDateTime = value
        }
        if (this.$baseLodash.isEmpty(row.endDateTime)) {
          row.endDateTime = value
        }

        if (
          !this.$baseLodash.isEmpty(row.startDateTime) &&
          !this.$baseLodash.isEmpty(row.endDateTime)
        ) {
          let isSame = this.$dayjs(row.startDateTime).isSame(
            row.endDateTime,
            'day'
          )
          if (!isSame) {
            row.disabled = true
            row.startTime = null
            row.endTime = null
            row.checkDisabled = true
            // 終日値は空です
            if (this.checkEnumFlag(row.dayFlag)) {
              row.dayFlag = this.$divisions.validFlgEnum.enum_0.value
            }
          } else {
            row.disabled = false
            row.checkDisabled = false
            row.dayFlag = this.$divisions.validFlgEnum.enum_0.value
          }
          if (row.scheduleAdjDetailId) {
            row.operationType = this.$divisions.operationTypeEnum.enum_U.value
          } else {
            row.operationType = this.$divisions.operationTypeEnum.enum_I.value
          }
          this.setWattingList(this.form.scheduleAdjDetailModelList)
        }
      },
      changeWattingTime(row) {
        if (row.scheduleAdjDetailId) {
          row.operationType = this.$divisions.operationTypeEnum.enum_U.value
        } else {
          row.operationType = this.$divisions.operationTypeEnum.enum_I.value
        }
      },
      // 終日
      changeDayFlag(val, row) {
        if (val === this.$divisions.validFlgEnum.enum_1.value) {
          row.disabled = true
          row.startTime = null
          row.endTime = null
        } else {
          row.disabled = false
        }
        this.$forceUpdate()
      },
      downLoadDateFile() {
        if (!this.isSave) return
        this.downLoadInfomation(
          '/api/scheduleAdjAnswer/partner/estimate/download'
        )
      },
    },
  }
</script>

<style lang="scss" scoped></style>
